// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"796":"895dcb9a","966":"214d2a85"}[chunkId] + ".chunk.js";
};